/* ==========================================================================
   Weespice cart drawer recommendations.

   Only does anything for the automatic source. The collection source is
   rendered straight from Liquid and needs no JavaScript at all.

   An ordinary page render cannot see Shopify's `recommendations` object, so
   the drawer lays out placeholders and this fetches the real strip from
   /recommendations/products with section_id=cart-recommendations, which
   renders the same snippet with recommendations populated.
   ========================================================================== */
(function () {
  if (customElements.get('ws-cart-recommendations')) return;

  /* Keyed by request URL and shared across instances. Adding an item re-renders
     the drawer, which re-runs this; without the cache the same seed product
     would be refetched every time the shopper changes a quantity. */
  var cache = {};

  function listOf(root) {
    return root.querySelector('[data-ws-rec-list]');
  }

  class WsCartRecommendations extends HTMLElement {
    connectedCallback() {
      /* The drawer refreshes through a hydration morph, which updates this
         element's attributes in place rather than replacing the node, so
         connectedCallback does not fire again. Watch the seed instead. */
      this.observer = new MutationObserver(
        function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            if (mutations[i].target === this) {
              this.load();
              return;
            }
          }
        }.bind(this)
      );
      this.observer.observe(this, { attributes: true });

      this.load();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.controller) this.controller.abort();
    }

    requestUrl() {
      var d = this.dataset;
      if (!d.url || !d.sectionId || !d.productId) return null;

      return (
        d.url +
        '?section_id=' +
        encodeURIComponent(d.sectionId) +
        '&product_id=' +
        encodeURIComponent(d.productId) +
        '&intent=' +
        encodeURIComponent(d.intent || 'related') +
        '&limit=' +
        encodeURIComponent(d.limit || '4')
      );
    }

    load() {
      if (this.dataset.source !== 'automatic') return;

      var url = this.requestUrl();
      if (!url) return;

      /* Guard against the morph re-running this for a seed we already
         rendered. The attribute is set after a successful fill and survives
         until the seed actually changes. */
      if (this.dataset.loadedUrl === url) return;

      var self = this;

      if (cache[url] != null) {
        self.fill(cache[url], url);
        return;
      }

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      fetch(url, { signal: this.controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Server returned ' + response.status);
          return response.text();
        })
        .then(function (html) {
          cache[url] = html;
          self.fill(html, url);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          /* Leave the placeholders rather than the shopper staring at a gap
             that used to hold something. */
          console.warn('[ws-cart-recommendations] ' + error.message);
        });
    }

    /**
     * Swaps the fetched list in. A response with no list means Shopify had no
     * recommendations and no fallback collection was set, so there is nothing
     * to show and the whole strip goes away.
     */
    fill(html, url) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var incoming = listOf(parsed);
      var current = listOf(this);

      if (!incoming || !incoming.children.length) {
        this.remove();
        return;
      }
      if (!current) return;

      current.innerHTML = incoming.innerHTML;
      this.dataset.loadedUrl = url;
      this.removeAttribute('aria-busy');
    }
  }

  customElements.define('ws-cart-recommendations', WsCartRecommendations);
})();
